import { cookie } from "cms-web-styleguide/dist/utils/utils";

const getCookies = () => {
  const cwcCookie = cookie.getCookie("tlnk_cwc");

  if (cwcCookie) {
    const cookieValues = cwcCookie.split(",");

    const newCookie = {};

    cookieValues.map((item) => {
      let cookie = item.split("=");

      newCookie[cookie[0]] = Boolean(cookie[1]);

      return cookie;
    });

    return newCookie;
  }
  return {};
};

const isCookieAccepted = () => {
  return document.cookie.includes("tlnk_cwc=necessary_cookies=true");
};

const isFileExists = (locale) => {
  try {
    return require(`../i18n/${locale}.json`);
  } catch {
    return null;
  }
};

const parseLocale = (locale) => {
  if (locale) {
    const localeArray = locale.split("-");

    return {
      lang: localeArray[0].toLowerCase(),
      market: localeArray[1].toLowerCase(),
    };
  }

  return null;
};

const setCookies = (chosenCookies) => {
  let expires = new Date();

  expires.setTime(expires.getTime() + 31536000000);

  let cwcCookie = "tlnk_cwc=necessary_cookies=true";

  if (chosenCookies) {
    if (chosenCookies.preferences) {
      cwcCookie += ",preferences=true";
    }

    if (chosenCookies.statisticsAnalyticsCookies) {
      cwcCookie += ",statistics_and_analytics=true";
    }

    if (chosenCookies.marketingCookies) {
      cwcCookie += ",marketing_cookies=true";
    }
  } else {
    cwcCookie += ",preferences=true,statistics_and_analytics=true,marketing_cookies=true";
  }

  cookie.setCookie(cwcCookie, expires.toUTCString());
};

const setEvent = (name) => {
  const event = new Event(name);

  dispatchEvent(event);
};

export { getCookies, isCookieAccepted, isFileExists, parseLocale, setCookies, setEvent };
